import axios from 'axios'
import CryptoJS from 'crypto-js'

axios.defaults.headers.common = {}
axios.defaults.headers.get = {}
axios.defaults.headers.post = {}
axios.defaults.headers.put = {}
axios.defaults.headers.delete = {}

const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname
 if (hostname.includes('yunres') || hostname === 'feidee.com') {
    return 'https://infra.feideetech.net/cab-customer-service'
  } else if (hostname.includes('yunrests')) {
    return 'http://172.22.23.104:3000'
  }
  // return '/cab-customer-service'
  return 'http://172.22.23.104:3000'
}

const API_BASE_URL = getApiBaseUrl()

const PUBLIC_HMAC_SECRET = 'Wt99NwBLzYgn8GttaTVpInmTgJjViXVLhngfCbGB6vE='

function isPublicProtectedPath(path: string): boolean {
  return path.startsWith('/api/docs/') || path.startsWith('/docs-html/')
}

function encodeQueryParam(value: string): string {
  return encodeURIComponent(value)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']')
}

function serializeQueryParams(params?: Record<string, string>): string {
  if (!params || Object.keys(params).length === 0) {
    return ''
  }
  return Object.keys(params)
    .sort()
    .map(key => `${encodeQueryParam(key)}=${encodeQueryParam(params[key])}`)
    .join('&')
}

function signPublicRequest({ method, path, body, params }: { method: string; path: string; body: string; params?: Record<string, string> }): Record<string, string> {
  const timestamp = String(Date.now())
  let signPath = path
  const queryString = serializeQueryParams(params)
  if (queryString) {
    signPath = `${path}?${queryString}`
  }
  const payload = [
    timestamp,
    method.toUpperCase(),
    signPath,
    body || ''
  ].join('')
  const signature = CryptoJS.HmacSHA256(payload, PUBLIC_HMAC_SECRET).toString(CryptoJS.enc.Hex)
  // console.log('HMAC Sign:', { timestamp, payload, signature })

  return {
    'X-Public-Timestamp': timestamp,
    'X-Public-Signature': signature
  }
}

export interface DocumentTreeNode {
  id: string
  type: 'directory' | 'document'
  title: string
  path: string
  order: number
  htmlPath?: string
  updatedAt?: number
  children?: DocumentTreeNode[]
}

export interface DocumentTreeResponse {
  handbook: DocumentTreeNode[]
  results?: {
    handbook?: DocumentTreeNode[]
  }
}

export type DocumentSearchResponse = DocumentTreeResponse

export interface DocumentApi {
  search(keyword: string, limit?: number): Promise<DocumentSearchResponse>
  getTree(): Promise<DocumentTreeResponse>
  getHtmlContent(url: string): Promise<string>
}

function getSignatureHeaders(method: string, path: string, params?: Record<string, string>): Record<string, string> {
  const headers: Record<string, string> = {}
  if (PUBLIC_HMAC_SECRET && isPublicProtectedPath(path)) {
    Object.assign(headers, signPublicRequest({
      method,
      path,
      body: '',
      params
    }))
  }
  return headers
}

export const documentApi: DocumentApi = {
  async search(keyword: string, limit?: number): Promise<DocumentSearchResponse> {
    const path = '/api/docs/search'
    const params: Record<string, string> = {
      q: keyword.trim()
    }
    if (limit) {
      params.limit = String(limit)
    }
    const queryString = serializeQueryParams(params)
    const requestUrl = `${API_BASE_URL}${path}${queryString ? `?${queryString}` : ''}`
    const response = await axios.get(requestUrl, {
      headers: getSignatureHeaders('get', path, params)
    })
    return response.data as DocumentSearchResponse
  },

  async getTree(): Promise<DocumentTreeResponse> {
    const path = '/api/docs/tree'
    const response = await axios.get(`${API_BASE_URL}${path}`, {
      headers: getSignatureHeaders('get', path)
    })
    return response.data as DocumentTreeResponse
  },

  async getHtmlContent(url: string): Promise<string> {
    const requestUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`
    const path = url.startsWith('http') ? new URL(url).pathname : url
    const urlObj = new URL(requestUrl)
    const params: Record<string, string> = {}
    urlObj.searchParams.forEach((value, key) => {
      params[key] = value
    })
    const response = await axios.get(requestUrl, {
      responseType: 'text',
      headers: getSignatureHeaders('get', path, params)
    })
    return response.data as string
  }
}

export { API_BASE_URL }
